@if (title()) {
    <qpx-dialog-header [title]="title()" presentation="confirmation" />
}

<qpx-dialog-content
    [isProcessing]="isProcessing()"
    [processingAppearance]="processingAppearance()"
>
    <ng-content />
</qpx-dialog-content>

<qpx-dialog-footer
    presentation="confirmation"
    [confirmButton]="resolvedConfirmButton()"
    [cancelButton]="cancelButton()"
    [confirmDisabled]="confirmDisabled()"
    [isProcessing]="isProcessing()"
    [processingAppearance]="processingAppearance()"
    (dismiss)="dismiss.emit()"
    (confirm)="confirm.emit()"
/>
